export default __webpack_public_path__ + "static/media/IMG_20190916_144203small.b263c9f7.jpg";